module.exports = __webpack_public_path__ + "static/media/logo-tilt.2482b0c5.png";